import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getPowerSystemCookie } from './auth'
// 创建axios实例
const service = axios.create({
  // baseURL: 'http://14.118.131.234:8443/user-service' // api 的 base_url  测试
  baseURL: process.env.VUE_APP_LOGIN_API
  // baseURL: 'http://190.168.0.77:8443/user-service', // api 的 base_url  测试
  // baseURL: 'http://47.112.12.109:8443/user-service', // api 的 base_url  生产
  // timeout: 5000 // 请求超时时间
})
// request拦截器
service.interceptors.request.use(
  config => {
    // const urlInfo = getPowerSystemCookie() ? JSON.parse(getPowerSystemCookie()) : {}
    // config.headers.Authorization = `Bearer ${urlInfo.token || ''}`
    const urlInfo = JSON.parse(sessionStorage.getItem('urlInfo'))
    config.headers.Authorization = `Bearer ${urlInfo.token}`

    config.headers.systemCode = process.env.VUE_APP_SYSTEM_CODE
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)
// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== '000000') {
      if (res.code === '000005' || res.code === '000008' || res.code === 401 || res.code === 403) {
        // window.location.href = `${process.env.VUE_APP_POWER_SYSTEM_URL}?redirect=${window.location.href}`
      } else {
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error('error'))
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
